<template>
    <div>
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100vh;">
            <!-- {{ quote_data }} -->
            <GardenHelpQuoteDetails class="m-5" v-if="quote_data != null && quote_job != null"
                :quote_table_items="quote_data.items" :contractor_name="quote_data.owner.name"
                :issue_date="quote_data.created_at" :booking_date="quote_job.details.booking_date_web"
                :quote_number="quote_data.invoice_number" :job_type="quote_job.property.type"
                :customer_name="quote_job.contact.name" :quote_status="quote_data.status" :subtotal="quote_data.subtotal"
                :vat="quote_data.vat" :vat_number="quote_data.owner.vat_number" :total="quote_data.total"
                :contractor_phone="quote_data.owner.phone" :contractor_email="quote_data.owner.email"
                :currency_code="currency_code" :currency_icon="currency_icon"
                :company_logo="company_logo" :company_reg_no="quote_data.owner.company_reg_no"
                :contractor_address="quote_data.owner.address" />
        </b-overlay>
        <!-- -->
    </div>
</template>

<script>
import { getJobStatusClassAndStr } from "@/utils/helper-functions-garden-help.js"
import { formatDateToDMonYear } from "@/utils/helper-functions.js"
import GardenHelpQuoteDetails from "./QuoteDetails.vue"
import countries_list from '@/assets/country-list-data.json'

import axios from "axios";

export default {
    name: "GardenHelpViewQuotePublic",
    components: {
        GardenHelpQuoteDetails
    },
    data() {
        return {
            client_name: "GARDENHELP",
            show_overlay: true,

            quote_id: null,
            quote_data: {
                "status": "",
                "subtotal": 0,
                "vat": 0,
                "total": 0,
                "currency": "eur",
                "model_type": "Job",
                "model_id": null,
                "client": "GARDENHELP",
                "invoice_items": []
            },
            quote_job: null,
            user_id: null,
            user_type: null,
            vat_no: null,

            action: 'view',
            base_url: null,
            payment_code: null,

            country: null,
            currency_code: null,
            currency_icon: null,

            company_logo: null,
            company_reg_no: null
        };
    },
    beforeMount() {
        this.show_overlay = true
    },
    mounted() {

        this.payment_code = this.$route.params.code;

        this.base_url = this.$route.path

        this.show_overlay = true
        this.getQuoteDetails()

        // if (this.user_type == 'operator') {
        //     this.getContractorData()
        // }
    },
    methods: {
        getQuoteDetails() {
            // this.show_overlay = true
            let requestData = { customer_code: this.payment_code }
            axios
                .post("jobs/invoice-by-customer-code", requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        // Authorization:
                        //     "Bearer " +
                        //     JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    this.quote_data = response.data.invoice
                    this.quote_job = response.data.invoice.model

                    this.currency_code = this.quote_data.currency
                    // console.log(response.data.invoice.currency)
                    const country_data = countries_list.find(({ currency_code }) => currency_code === this.currency_code);
                    // console.log(country_data)

                    this.country = country_data.country
                    this.currency_icon = country_data.currency_icon

                    this.show_overlay = false

                    // this.getJobDetails(response.data.invoice.id)
                    // console.log(response.data.invoice.owner.id)
                    // this.getContractorData(response.data.invoice.owner.id)
                });
        },
        // getJobDetails(id) {
        //     axios
        //         .get("/jobs/jobs/" + id, {
        //             headers: {
        //                 Accept: "application/json",
        //                 "Content-Type": "application/json",
        //                 client: this.client_name,
        //                 // Authorization:
        //                 //     "Bearer " +
        //                 //     JSON.parse(window.localStorage.getItem("user")).access_token,
        //             },
        //         })
        //         .then((response) => {
        //             console.log(response)
        //             console.log(response.data)
        //             console.log(response)

        //             this.quote_job = response.data

        //             // this.show_overlay = false
        //         });
        // },

        // getContractorData(contractor_id) {
        //     console.log("in get contractor data", this.user_type, this.user_id)
        //     this.show_overlay = true

        //     axios
        //         .get("/operator/contractor/profile/" + contractor_id, {
        //             headers: {
        //                 Accept: "application/json",
        //                 "Content-Type": "application/json",
        //                 client: this.client_name,
        //                 // Authorization:
        //                 //     "Bearer " +
        //                 //     JSON.parse(window.localStorage.getItem("user")).access_token,
        //             },
        //         })
        //         .then((response) => {
        //             console.log(response)
        //             console.log(response.data)
        //             this.vat_no = response.data.vat_no
        //             this.company_logo = response.data.logo
        //             this.show_overlay = false

        //         });
        // },
    }
};
</script>
<style scoped::v-deep >
@import "../styles/garden-help-button-styles.css";
@import "../styles/garden-help-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/ViewQuotePublic.vue